import { type FC, useState } from 'react';
import type { MarketsActiveFilter } from '@mwl/core-lib';
import { getMarketsCountForFilters, getMarketsOutcomesTotalCount } from '@mwl/core-lib';
import { Markets } from '@/components/Markets/Markets';
import { Header } from './components/Header/Header';
import { MarketsFilter } from './components/MarketsFilter/MarketsFilter';
import type { LinePageProps } from './LinePage.types';
export const LinePage: FC<LinePageProps> = ({
  line
}) => {
  const [activeFilter, setActiveFilter] = useState<MarketsActiveFilter>(null);
  const handleFilterClick = (filterId: MarketsActiveFilter) => {
    setActiveFilter(current => current === filterId ? null : filterId);
  };
  const matchFinished = line.status !== 'OPENED' && line.status !== 'PAUSED';
  return <>
      <Header line={line} data-sentry-element="Header" data-sentry-source-file="LinePage.tsx" />
      {!matchFinished && <MarketsFilter filters={line.marketFilters} counts={getMarketsCountForFilters(line.marketFilters, line.markets)} totalCount={getMarketsOutcomesTotalCount(line.markets)} activeFilter={activeFilter} onFilterClick={handleFilterClick} />}
      <Markets lineId={line.id} lineStage={line.stage} markets={line.markets} isPaused={line.status === 'PAUSED'} isFinished={matchFinished} activeFilter={matchFinished ? null : activeFilter} data-sentry-element="Markets" data-sentry-source-file="LinePage.tsx" />
    </>;
};